//Base URL Will be used on the utility JS file
// export const apiUrl = `https://dev-backend-apps.animeta.ai`

export const creators = {
  getCreatorsList: `/creator/getAllCreators`,
  getRisingStarsFilterData: `/creator/risingstar/filters`,
  exportRisingStar: `/creator/getAllRaisingStar/export`,
  getFilterData: `/creator/getFilterData`,
  // getCreatorsDetails: `${creatorUrl}/getCreatorById`,
  getRisingStars: `/creator/getRisingStarData`,
  getCreatorLocations: `/creator/globalLocation/info`,
  getCreatorCities: `/creator/globalLocation-state/info`,
  getCreatorProfileDetails: `/creator/profile`,
  getCreatorProfileFormDetails: `/creator/profile/draft`,
  publishProfileForm: `/creator/profile/publish`,
  addProfileNotes: `/creator/profile/addNotes`,
  getProfileNotes: `/creator/profile/getNotes`,
  getProfileConstants: `/creator/profile/dropDown`,
  getCreatorMixId: `/creator/getCreatorMixId`,
  getProfilePlatformData: `/creator/profile`,
  getCreatorCollabFilter: `/creator/profile/collabs/filter`,
  // getCreatorCollabs: `${creatorUrl}/profile/collabs`,
  getCreatorsUnderCampaign: `/shortlist/get/campaign/creators`,
  getCreatorShorlistNames: `/shortlist/frombrand`,
  getCreatorShorlistList: `/shortlist`,
  addShorlistCreators: `/shortlist/add/creator`,
  addCreatorsToCampaign: `/shortlist/add/creator/tocampaign`,
  getShortlistCreators: `/shortlist/get/creators`,
  removeCreatorsFromShortlist: `/shortlist/remove/creators`,
  deleteShortlistCreators: `/shortlist`,
  updateCreatorShorlistList: `/shortlist/updateListName`,
  creatorUploadImage: `/creatorOnboarding/creatorUploadImage`,
  exportCreators: `/creator/getAllCreators/export`,
  getSimilarCreators: `/creator/getSimilarCreators`,
  getCreatorPerformanceData: `/creator/getCreatorPerformanceData`,
  getCreatorCity: '/creator/getAllCreators/locationSearchByCity',
  getStateAndCountry: `/creator/getAllCreators/cityInfo`,
  exportMyListCreators: `/shortlist/get/creators/mylistExportExcel`,
  getNormalizedView: `/creator/getNormalizedView`,
  refreshCreator: `/creator/refreshCreator`,
  refreshCreatorYT: `/creator/refreshYTCreator`,
  getDropdownSearchData: `/creator/getDropdownSearchData`,
  addCreatorImportExcel: `/creator/importCreatorFromExcel`,
  contentGenre: `/creator/getAllCreators`,
  snapCategoriesDropdowns: "/creator/profile/SnapDropDown",
  instaAudienceFilter: `/creator/getAllCreators/instaAudienceFilter`,
  addProductsConfig: `/products`,
  getBuyingPlatform: `/platforms`,
  getProductConfig: `/products`,
  editProductById: `/products`,
};

export const auth = {
  // signup: `${oldUserUrl}/signup`,
  // sendOtp: `${oldUserUrl}/sendOTP`,
  // verifyOtp: `${oldUserUrl}/verifyOTP`,
  login: `/user/login`,
  forgotPassword: `/user/forgotpassword`,
  resetPassword: `/user/resetpassword`,
  // advertiserCategories: `${oldBaseUrl}/config/advertiserCategory`,
  logout: `/user/logout`,
  // validToken: `${oldUserUrl}/token/isvalid`,
  isValidToken: `/user/token/isvalid`,
  updatePassword: `/user/update/Password`,
  authentication: `/user/recaptcha`
};

export const brands = {
  getBrandsList: `/brands/getBrandsList`,
  getBrandCategories: `/brands/getAllBrandCategories`,
  createBrand: `/brands/createBrand`,
  updateBrand: `/brands/update`,
  listAllBrands: `/brands/list`,
  globalBrandsAndCampaign: `/brands/searchGlobalBrandAndCampaignList`
};

export const newBrands = {
  getNewBrandsList: '/brandAffiliate/brand',
}

export const campaign = {
  allConfig: `/config/all`,
  createCampaign: `/campaign/create`,
  getAllDraft: `/brands`,
  getCampaign: `/campaign`,
  getBrandCampaignList: `/brands`,
  submitforActivation: `/campaign/sent/request`,
  managementList: `/campaign/management/creators`,
  listStatusUpdate: `/campaign/management/update/creator`,
  platformTypeContents: `/config`,
  addDeliverables: `/campaign/management/add/deliverables`,
  getDeliverables: `/campaign/management/get/deliverables`,
  updateDeliverables: `/campaign/management/update/deliverable`,
  deleteDeliverables: `/campaign/management/deliverables`,
  exportToExcelShortlisted: `/shortlist/campaign/creators/exportExcel`,
  exportToExcelMgmt: `/campaign/management/exportExcel`,
  creatorMixGenerate: `/creator/getCreatorMix`,
  removeCampaignShortlist: `/campaign/remove/shortlist/creator`,
  generateSocialCommerceLink: `/campaign/generate/affiliate/link`,
  updateCampaign: '/campaign/updateCampaign',
  generateCoupon: `/campaign/generateCoupons`,
  getCoupons: `/campaign/getCoupons`,
  updateCampaignEndDate:`/campaign/updateCampaignEndDate`,
  getAllCampaignWioutBrand: `/brands/select_brand/campaign`,
};

export const collabs = {
  allCollabs: `/videos/getCreatorsCollabsData`,
  collabsFilterData: `/videos/getCreatorsCollabsFilterData`,  
  // allCollabs: `/videos/getCollabsData/new`,
  // collabsFilterData: `/videos/getCollabsFilterData`,
};


export const company = {
  company: `/user/companies/list`,
};

export const accounts = {
  accountsList: `/user/accounts`,
  companyList: `/user/companies/list`,
};

export const performance = {
  monitoringData: `/campaign/performance/graph`,
  creatorsList: `/campaign/performance/deliverables`,
  creatorsNameList: `/campaign/performance/filter/creators`,
  exportToExcel: `/campaign/performance/export/excel`,
  platformList: `/campaign/performance/filter/platform`,
  overall: `/campaign/performance/graph/overall`,
  socialCommerceList: `/campaign/performance/affiliateDeliverables`,
  getPreviewPageGraph: `/campaign/performance/graphPDF`,
  getProductView: `/campaign/getProduct/metricsOfPerformanceCreator`
}

export const user = {
  createUser: `/user/createUser`,
  listUser: `/user/getAllUsers`,
  getUserById: `/user/geUser`,
  getAllRoleInfo: `/role/getAllRoleInfo`,
  editUserById: `/user/editUser`,
  deleteUserById: `/user/deleteUser`
}

export const organization = {
  getOrganisationList: `/org/getAllOrg`,
  addOrganisation: `/org/addOrg`,
  organisationById: `/org/getOrgInfo`,
  organisationaddWallet: `/org/wallet`,
  getOrganisationWalletList: `/org/walletHistory`,
  getCreditInfo: `/org/wallet`,
  updateOrgById: `/org/updateOrgInfo`,
  updateStatusById: `/org/activate`,
  creditsApi: `/org/wallet/balance`

}
//Commone List API
export const commonDropdownList = {
  getAllSubscriptionInfo: `/org/getAllSubscriptionInfo`
}

//Products Endpoints
export const products = {
  productsEndpoints: `/brandAffiliate/products`,
  getCategories: `/brandAffiliate/categories`
}

//Animeta Certified page
export const aniCertifiedUsers = {
  getAniUserList: `/creator/getAnimetaCertifiedUserData`
}

//Animeta DashBoard Apis
export const aniDashboard = {
  getEarningMetrics: `/analytics/EarningMetrics`,
  getAnalyticsCreatorLineGraph: `/analytics/CreatorsLineGraph`,
  getAnalyticsBrandLineGraph: `/analytics/BrandsLineGraph`,
  getEarningBarGraph: `/analytics/EarningBarGraph`
}

export const dashboardCampaign = {
  getEngagements: `/analytics/Engagements`,
  getAllCampaign: `/analytics/filter/CampaignsList`,
  getAllCreatorList: `/analytics/filter/CreatorsList`,
  getCampaignGraphData: `/analytics/getCampaignGraphicaldata`,
  getAllCampaignList: `/analytics/getCampaignsList`,
}

export const dashboardDetailedView = {
  getSalesCommissionDetailedView:`/analytics/DetailedView/SalesAndComissions`,
  getCampaignDetailedView: `/analytics/DetailedView/CampaignAnalytics`,
  getBrandFilter:`/analytics/filter/affiliateBrands`,
  getProductFilter:`/analytics/filter/AffiliateProducts`,
};

export const productView = {
  getProductDetail: `/products/slug`,
  trackProductVisit: `/metrics/track-page-visit`,
  trackBuying: `/metrics/track`,
}